import React from "react";
import './_css/MCSFormDisplay.css';

const MCSFormDisplay = (props) => {

    return(
        <>
        <b className="mcs-display-label">{props.labelName}</b><br/>
        <span className="mcs-display-data">{props.data}</span>
        </>
    );

}

export default MCSFormDisplay;